export const patientCreateOrUpdate = {
  patientCreated: "Patient created successfully",
  patientUpdated: "Patient updated successfully"
};
